import React from 'react'
import _ from 'lodash'
import Griddle from 'griddle-react'
import { Link } from 'react-router'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { getToken } from '../../Commons/Authentication'
import NavigationBar from '../../Commons/NavigationBar'
import { ToastContainer, ToastMessage } from 'react-toastr'
import SearchImage from '../../../img/icons/general-icons/search_icon.png'
import LinkUpdateEps from './LinkUpdateEps'
import NotDataAvailable from './NotDataAvailable'
import EditIcon from '../../../img/icons/general-icons/icon_edit.png'
import EpsIcon from '../../../img/icons/general-icons/add_user_icon.png'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class SearchEps extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ epsList: [], showTable: true })
    this.listEps()
  }

  listEps () {
    request
    .get('api/v1/eps/')
    .set('Authorization', 'Bearer ' + getToken())
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (res.statusCode === 200) {
        this.setState({ epsList: res.body })
      } else {
        if (err) {
          this.refs.container.error('Algo inesperado ocurrió, no se encontraron eps', '', {
            closeButton: true
          })
        }
      }
    })
  }

  showEpsTable () {
    this.setState({ showTable: true })
  }

  findTypeAhead () {
    let val = this.refs.query.value
    let url = `api/v1/eps/typeahead?nombre=${val}`
    request
    .get(url)
    .set('Authorization', 'Bearer ' + getToken())
    .use(NoCache)
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (res) {
        this.setState({ epsList: res.body })
        this.showEpsTable()
      } else {
        if (err) {
          this.refs.container.error('No se encontro información de la eps', '', {
            closeButton: true
          })
        }
      }
    })
  }

  render () {
    document.title = 'Listado de Pacientes - CORE 3.0'
    var information = this.state.epsList
    var epsData = []
    var idsData = []
    var columnsData = [
      {
        'columnName': 'Nombre'
      },
      {
        'columnName': 'Estado'
      },
      {
        'columnName': ' ',
        'customComponent': LinkUpdateEps
      }
    ]
    _.forEach(information, (key, vals) => {
      epsData.push({
        'Nombre': key.nombre,
        'Estado': key.status ? 'activo' : 'inactivo',
        ' ': EditIcon
      })
    })
    return (
      <div className='form-page-container'>
        <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
        <NavigationBar />
        <div className='form-field-container'>
          <img className='form-field-image' src={SearchImage}/>
          <input id='searchEps' ref='query' className='form-input-search' onChange={(e) => { this.findTypeAhead() }} type='text' placeholder='Buscar EPS....' />
        </div>
        <div className='table-container'>
          <Griddle tableClassName='table' showFilter={false} showSettings={false} customNoDataComponent={NotDataAvailable} columnMetadata={columnsData} results={epsData} resultsPerPage={10} enableInfiniteScroll={true} bodyHeight={350}/>
        </div>
        <div className='form-field-new-eps'>
          <img className='form-field-image' src={EpsIcon} />
          <Link className='form-link-new-eps' to={'/eps'}>Ingresar nueva EPS</Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EPS/SearchEps/SearchComponent.js